export const productArray = [
    {
        itemName: "Overview",
        detail: "Explore Mayheaven",
        icon: "bx bxl-dropbox"
    },
    {
        itemName: "Analysis",
        detail: "Analyze at light speed",
        icon: "bx bx-edit-alt"
    },
    {
        itemName: "Insight",
        detail: "Find answer instantly",
        icon: "bx bx-bar-chart"
    },
    {
        itemName: "Channels",
        detail: "Track feedback",
        icon: "bx bxs-chevrons-up"
    },
    {
        itemName: "Integration",
        detail: "Connect your tool",
        icon: "bx bx-cloud-upload"
    },
    {
        itemName: "Product managers",
        detail: "Data driven decision",
        icon: "bx bxs-chalkboard"
    },
]
export const resourcesArray = [
    {
        itemName: "Blog",
        detail: "Read our latest articles",
        icon: "bx bx-book"
    },
    {
        itemName: "Webinars",
        detail: "Join our webinars",
        icon: "bx bx-video"
    },
    {
        itemName: "Guides",
        detail: "Download guides",
        icon: "bx bx-download"
    },
    {
        itemName: "Case Studies",
        detail: "See our success stories",
        icon: "bx bx-folder-open"
    },
    {
        itemName: "FAQs",
        detail: "Find answers quickly",
        icon: "bx bx-help-circle"
    },
    {
        itemName: "Support",
        detail: "Get help from our team",
        icon: "bx bx-headphone"
    }
];
export const customerArray = [
    {
        itemName: "Testimonials",
        detail: "Hear from our clients",
        icon: "bx bx-comment"
    },
    {
        itemName: "Reviews",
        detail: "Read user reviews",
        icon: "bx bx-star"
    },
    {
        itemName: "Feedback",
        detail: "Give us your feedback",
        icon: "bx bx-edit"
    },
    {
        itemName: "Community",
        detail: "Join our community",
        icon: "bx bx-group"
    },
    {
        itemName: "User Stories",
        detail: "Read user experiences",
        icon: "bx bx-bookmark"
    },
    {
        itemName: "Referral Program",
        detail: "Refer and earn rewards",
        icon: "bx bx-gift"
    }
];
export const enterpriseArray = [
    {
        itemName: "Solutions",
        detail: "Enterprise solutions",
        icon: "bx bx-cube"
    },
    {
        itemName: "Partners",
        detail: "Our enterprise partners",
        icon: "bx bx-link"
    },
    {
        itemName: "Integrations",
        detail: "Enterprise integrations",
        icon: "bx bx-plug"
    },
    {
        itemName: "Security",
        detail: "Our security measures",
        icon: "bx bx-shield"
    },
    {
        itemName: "Compliance",
        detail: "Regulatory compliance",
        icon: "bx bx-certification"
    },
    {
        itemName: "Contact Sales",
        detail: "Reach our sales team",
        icon: "bx bx-phone"
    }
];
